/* XO & CO. - a little Christmas magic. Pauses off-screen; respects reduced motion. */
(function () {
if (window.__xoMagic) { window.__xoMagic.init(document); return; }
document.documentElement.classList.add('xo-js');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var finePointer = window.matchMedia('(pointer: fine)').matches;
var inEditor = !!(window.Shopify && window.Shopify.designMode);

function sparkle(x, y, n, spread) {
if (reduce) return;
for (var i = 0; i < (n || 5); i++) {
var s = document.createElement('span');
s.className = 'xo-sparkle';
var a = Math.random() * Math.PI * 2, d = (spread || 36) * (0.4 + Math.random() * 0.6), z = 3 + Math.random() * 5;
s.style.left = (x - z / 2) + 'px'; s.style.top = (y - z / 2) + 'px';
s.style.width = s.style.height = z + 'px';
s.style.setProperty('--dx', Math.cos(a) * d + 'px');
s.style.setProperty('--dy', (Math.sin(a) * d - 12) + 'px');
s.style.animationDelay = (Math.random() * 120) + 'ms';
document.body.appendChild(s);
setTimeout(function (el) { el.remove(); }, 1200, s);
}
}
function sparkleAround(el, n) {
var r = el.getBoundingClientRect();
for (var i = 0; i < (n || 4); i++) sparkle(r.left + Math.random() * r.width, r.top + Math.random() * r.height, 1, 26);
}

/* golden burst from a point, drawn on a temporary full-screen canvas */
function burst(x, y) {
if (reduce) return;
var c = document.createElement('canvas'), ctx = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
c.className = 'xo-burst-canvas';
c.width = innerWidth * dpr; c.height = innerHeight * dpr; ctx.scale(dpr, dpr);
document.body.appendChild(c);
var parts = [], n = innerWidth < 600 ? 90 : 140;
for (var i = 0; i < n; i++) {
var a = Math.random() * Math.PI * 2, v = 2 + Math.random() * 7;
parts.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 2.5, r: 0.8 + Math.random() * 2.4, life: 0, max: 50 + Math.random() * 50, tw: Math.random() * 6 });
}
(function tick() {
ctx.clearRect(0, 0, innerWidth, innerHeight);
var alive = 0;
for (var i = 0; i < parts.length; i++) {
var p = parts[i];
if (p.life++ > p.max) continue;
alive++;
p.vx *= 0.96; p.vy = p.vy * 0.96 + 0.06; p.x += p.vx; p.y += p.vy;
var o = 1 - p.life / p.max, g = 0.6 + Math.sin(p.life * 0.4 + p.tw) * 0.4;
ctx.fillStyle = 'rgba(244,222,170,' + (o * g).toFixed(3) + ')';
ctx.shadowColor = 'rgba(255,215,140,.9)'; ctx.shadowBlur = 8;
ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
}
if (alive) requestAnimationFrame(tick); else c.remove();
})();
}

/* snow + drifting gold dust */
function Particles(canvas) {
var ctx = canvas.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
var flakes = [], w = 0, h = 0, running = false;
var snow = canvas.getAttribute('data-snow') !== 'false', gold = canvas.getAttribute('data-gold') !== 'false';
var density = parseFloat(canvas.getAttribute('data-density') || '1');
function make(any) {
var isGold = gold && (!snow || Math.random() < 0.3);
return { gold: isGold, x: Math.random() * w, y: any ? Math.random() * h : -8, r: isGold ? 0.5 + Math.random() * 1.3 : 0.7 + Math.random() * 2, vy: isGold ? -0.06 + Math.random() * 0.16 : 0.22 + Math.random() * 0.55, vx: -0.12 + Math.random() * 0.24, p: Math.random() * 6.283, tw: 0.01 + Math.random() * 0.03, o: isGold ? 0.35 + Math.random() * 0.6 : 0.3 + Math.random() * 0.5 };
}
function size() {
var r = canvas.getBoundingClientRect(); w = r.width; h = r.height;
canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
var n = Math.max(16, Math.min(Math.round(w * h / 15000 * density), w < 600 ? 55 : 110));
flakes = []; for (var i = 0; i < n; i++) flakes.push(make(true));
}
function frame() {
ctx.clearRect(0, 0, w, h);
for (var i = 0; i < flakes.length; i++) {
var f = flakes[i]; f.p += f.tw; f.x += f.vx + Math.sin(f.p) * 0.3; f.y += f.vy;
if (f.y > h + 8 || f.y < -20 || f.x < -20 || f.x > w + 20) { flakes[i] = make(false); if (f.gold) flakes[i].y = Math.random() * h; continue; }
if (f.gold) { ctx.fillStyle = 'rgba(236,210,150,' + (f.o * (0.55 + Math.sin(f.p * 3) * 0.45)).toFixed(3) + ')'; ctx.shadowColor = 'rgba(255,215,140,.9)'; ctx.shadowBlur = 6; }
else { ctx.fillStyle = 'rgba(253,251,246,' + f.o.toFixed(3) + ')'; ctx.shadowBlur = 0; }
ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill();
}
ctx.shadowBlur = 0;
if (running) requestAnimationFrame(frame);
}
function start() { if (!running && !document.hidden) { running = true; requestAnimationFrame(frame); } }
function stop() { running = false; }
size();
var t; addEventListener('resize', function () { clearTimeout(t); t = setTimeout(size, 200); });
if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }).observe(canvas); else start();
document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
}

var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (!e.isIntersecting) return;
e.target.classList.add('is-visible'); io.unobserve(e.target);
if (e.target.hasAttribute('data-xo-burst')) { var r = e.target.getBoundingClientRect(); setTimeout(function () { sparkle(r.left + r.width / 2, r.top + 30, 8, 70); }, 400); }
});
}, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;

/* Discover the Magic: burst, golden veil, then glide inside */
function enter(btn) {
var target = document.querySelector(btn.getAttribute('href'));
if (!target) return;
if (reduce) { target.scrollIntoView(); return; }
var r = btn.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
burst(x, y);
var veil = document.createElement('div');
veil.className = 'xo-veil';
veil.style.setProperty('--x', (x / innerWidth * 100) + '%');
veil.style.setProperty('--y', (y / innerHeight * 100) + '%');
document.body.appendChild(veil);
setTimeout(function () { veil.classList.add('is-in'); }, 380);
setTimeout(function () { target.scrollIntoView({ behavior: 'instant', block: 'start' }); veil.classList.add('is-out'); }, 1420);
setTimeout(function () { veil.remove(); }, 2500);
}

function header(el) {
if (!el.hasAttribute('data-xo-transparent')) return;
var on = function () { el.classList.toggle('is-solid', scrollY > 40); };
on(); addEventListener('scroll', on, { passive: true });
}

function init(root) {
root.querySelectorAll('.xo-magic-canvas:not([data-xo-ready])').forEach(function (c) { c.setAttribute('data-xo-ready', ''); if (!reduce) Particles(c); });
root.querySelectorAll('.xo-reveal:not([data-xo-ready])').forEach(function (el) { el.setAttribute('data-xo-ready', ''); if (io && !inEditor) io.observe(el); else el.classList.add('is-visible'); });
root.querySelectorAll('.xo-btn:not([data-xo-ready]),[data-xo-twinkle]:not([data-xo-ready])').forEach(function (el) {
el.setAttribute('data-xo-ready', '');
el.addEventListener('pointerenter', function () { if (finePointer) sparkleAround(el, 4); });
el.addEventListener('pointerdown', function (ev) { sparkle(ev.clientX, ev.clientY, 6, 40); });
});
root.querySelectorAll('[data-xo-enter]:not([data-xo-on])').forEach(function (btn) {
btn.setAttribute('data-xo-on', '');
btn.addEventListener('click', function (ev) { if ((btn.getAttribute('href') || '').charAt(0) !== '#') return; ev.preventDefault(); enter(btn); });
});
root.querySelectorAll('[data-xo-header]:not([data-xo-on])').forEach(function (el) { el.setAttribute('data-xo-on', ''); header(el); });
root.querySelectorAll('[data-xo-close]:not([data-xo-on])').forEach(function (b) {
b.setAttribute('data-xo-on', '');
b.addEventListener('click', function () { var d = b.closest('details'); if (d) d.open = false; });
});
root.querySelectorAll('.xo-menu a').forEach(function (a) { a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; }); });
root.querySelectorAll('.xo-rail:not([data-xo-on])').forEach(function (rail) {
rail.setAttribute('data-xo-on', '');
var dots = rail.parentNode.querySelectorAll('.xo-rail-hint span');
if (!dots.length) return;
rail.addEventListener('scroll', function () {
var i = Math.round(rail.scrollLeft / (rail.scrollWidth - rail.clientWidth || 1) * (dots.length - 1));
dots.forEach(function (d, j) { d.style.background = j === i ? 'var(--xo-gold-soft)' : ''; });
}, { passive: true });
});
}
window.__xoMagic = { init: init, sparkle: sparkle, burst: burst };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
